module.exports = __webpack_public_path__ + "img/phone.5b87672b.svg";